import PropTypes from 'prop-types'

import useIsMobile from '../../../../hooks/useIsMobile'
import BasicInfoSection from './BasicInfoSection'
import TrackingSectionDesktop from './TrackingSectionDesktop'
import OriginDestinationSection from './OriginDestinationSection'
import useShippingActions from '../../../../App/ShippingsTracking/TrackingTable/useShippingActions'
import { Box, Button, Typography } from '@mui/material'
import styles from '../styles'
import useTranslations from '../../../../i18n/useTranslations'
import {
  INCIDENTS_CODES_ALLOWED_FOR_RESOLUTION,
  SHIPPING_STATUS_CODES,
} from '../../../../common/constants'
import { ReactComponent as Edit } from '../../../../assets/icons/edit.svg'

const Content = ({
  data,
  state,
  trackingLineData,
  showFullTrackingButton,
  activateReturnShippingInfo,
  cancelActivateReturn,
  onOpenFullTrackingDrawer,
  setScheduledPickupShippingsInfo,
  setIncidentBeingSolved,
}) => {
  const isMobile = useIsMobile()
  const t = useTranslations()
  const { determineShippingActionsMobile } = useShippingActions()

  const isSolvable =
    state?.length &&
    INCIDENTS_CODES_ALLOWED_FOR_RESOLUTION.includes(state[0]?.incidentCode) &&
    (state[0]?.lastStatusCode === SHIPPING_STATUS_CODES.incidentDelivering ||
      state[0]?.lastStatusCode === SHIPPING_STATUS_CODES.delivering)

  const isResolved = trackingLineData?.stepsData?.find(
    e => e.code === state[0]?.lastStatusCode,
  )?.isResolved

  const rowActions = Object.entries(
    determineShippingActionsMobile(data.info),
  ).filter(action => action[1].isActive)

  return (
    <>
      {isMobile ? (
        <Box sx={{height:'100%'}}>
          <BasicInfoSection data={data} state={state} />
          <OriginDestinationSection
            data={{
              shipmentInfo: data.info,
              state: state,
              shipmentStatus: data.info.shippingStatusCode.severity,
              from: data.from,
              to: data.to,
            }}
          />
          <Box sx={styles.actionsButtons}>
            {rowActions.map(([actionType, actionConfig]) => (
              <Button
                sx={{ width: '100%' }}
                size={'medium'}
                variant="outlined"
                key={actionType}
                onClick={actionConfig.onClick}
              >
                {actionConfig.label}
              </Button>
            ))}
            {data?.info?.pickupUnscheduled || isSolvable ? (
              <Button
                size="small"
                variant={'outlined'}
                onClick={() => {
                  onOpenFullTrackingDrawer()
                }}
                style={styles.ghostButton}
              >
                {t('shipping-tracking:see-complete-tracking')}
              </Button>
            ) : null}
          </Box >
          {isResolved ? (
            <Box sx={styles.resolvedParent}>
              <Typography
                component="span"
                variant="subtitle1"
                sx={styles.resolved}
              >
                {t('shipping-tracking:already-resolved')}
              </Typography>
            </Box>
          ) : null}
          <Button
            size="small"
            disabled={isResolved}
            onClick={() => {
              if (isSolvable) setIncidentBeingSolved()
              else if (data?.info?.pickupUnscheduled)
                setScheduledPickupShippingsInfo()
              else onOpenFullTrackingDrawer()
            }}
            style={styles.stickyButton}
            startIcon={isSolvable ? <Edit /> : null}
          >
            {isSolvable
              ? t('noun:resolve-incident')
              : data?.info?.pickupUnscheduled
              ? t('action:schedule-pickup')
              : t('shipping-tracking:see-complete-tracking')}
          </Button>
        </Box>
      ) : (
        <TrackingSectionDesktop
          data={data}
          cancelActivateReturn={cancelActivateReturn}
          activateReturnShippingInfo={activateReturnShippingInfo}
          trackingLineData={trackingLineData}
          showFullTrackingButton={showFullTrackingButton}
          onOpenFullTrackingDrawer={onOpenFullTrackingDrawer}
        />
      )}
    </>
  )
}

Content.propTypes = {
  data: PropTypes.object,
  state: PropTypes.object,
  activateReturnShippingInfo: PropTypes.object,
  cancelActivateReturn: PropTypes.func,
  trackingLineData: PropTypes.object,
  showFullTrackingButton: PropTypes.bool,
  onOpenFullTrackingDrawer: PropTypes.func,
  setIncidentBeingSolved: PropTypes.func,
  setScheduledPickupShippingsInfo: PropTypes.func,
}

export default Content
